import { QuestionBase } from './question-base';

export class HeaderQuestion extends QuestionBase<string> {
  controlType = 'header';

  type: string;

  hasRemove: boolean;

  constructor(options: any = {}) {
    super(options);
    this.type = options.type || '';
    this.hasRemove = false;
  }
}
